import React from "react"
import { ExclamationCircleFilled } from "@ant-design/icons"
import { Tooltip } from "antd"
import { TooltipPlacement } from "antd/es/tooltip"
import { AlertTriangle } from "react-feather"

interface HoverableInfoInterface {
    message: string
    iconClassName?: string
    overlayInnerStyle?: React.CSSProperties
    placement?: TooltipPlacement
    type?: "info" | "warn"
}
export const HoverableInfo = ({ message, iconClassName = "ml-6", overlayInnerStyle = {}, placement = "top", type = "info" }: HoverableInfoInterface) => {
    const icon =
        type === "warn" ? (
            <AlertTriangle fill="#FBAC3B" size={18} stroke="#FFFFFF" className={iconClassName} />
        ) : (
            <ExclamationCircleFilled className={iconClassName} style={{ color: "#3866FF" }} />
        )
    
    const getPopupContainer = (triggerNode: HTMLElement) => {
        let parent = triggerNode?.parentNode?.parentNode?.parentNode
        
        //* in case of parent is one of the following jump to the next parent
        //* table wrappers blocks the tooltip from getting the size it needs
        const tagNameList = ['TR', 'TH', 'THEAD', 'TD', 'TABLE']
        while (parent?.nodeName && tagNameList.includes(parent?.nodeName)) {
            parent = parent?.parentNode?.parentNode
        }
        
        return parent as HTMLElement
    }

    return (
        <Tooltip getPopupContainer={getPopupContainer} title={message} placement={placement} className="align-middle" overlayInnerStyle={overlayInnerStyle}>
            {icon}
        </Tooltip>
    )
}
